// Saves an unfinished participation on the device so it survives the page
// reload mobile browsers do after the player opens Instagram / Facebook.
const TTL_MS = 2 * 60 * 60 * 1000;
const storageKey = (key) => `qrise_progress_${key}`;

export function loadProgress(key) {
  try {
    const p = JSON.parse(localStorage.getItem(storageKey(key)) || "null");
    if (p && Date.now() - p.saved_at < TTL_MS) return p;
    localStorage.removeItem(storageKey(key));
  } catch {
    clearProgress(key);
  }
  return null;
}

export function saveProgress(key, data) {
  try {
    localStorage.setItem(storageKey(key), JSON.stringify({ ...data, saved_at: Date.now() }));
  } catch {
    /* storage unavailable (private mode) */
  }
}

export function clearProgress(key) {
  try {
    localStorage.removeItem(storageKey(key));
  } catch {
    /* storage unavailable */
  }
}
